import Layout from '@/layout/index'
import System from './system.js'
import Party from './party.js'
import eLife from './eLife.js'
import ePower from './ePower.js'
import Talent from './talent.js'

export default {
  path: '/',
  component: Layout,
  redirect: '/dashboard',
  // name: 'home',
  meta: { title: '首页' },
  children: [
    {
      path: 'dashboard',
      component: () => import('@/views/Dashboard'),
      name: 'Dashboard',
      meta: { title: '首页' }
    },
    // {
    //   path: 'statistics',
    //   component: () => import('@/views/Statistics'),
    //   name: 'Statistics',
    //   meta: { title: '数据统计' }
    // },
    System,
    Party,
    eLife,
    ePower,
    Talent
  ]
}
